import { useState } from "react";
import { getAPIRequest } from "../Axios/AxiosRequestConfiguration";
import getRequestInterface from "../Axios/getRequestInterface";

export const useGetApi = (
  onSuccess?: (data: any) => void,
  onError?: (error: any) => void
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [responseData, setResponseData] = useState<any>(null);

  const makeRequest = async (url: string, onSettle?: () => void) => {
    setLoading(true);
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        setResponseData(response["data"]);
        if (typeof onSuccess === "function") {
          onSuccess(response["data"]);
        }
        setLoading(false);
        if (typeof onSettle === "function") {
          onSettle();
        }
      },
      failure: (err: any) => {
        setLoading(false);
        setError(err);
        if (typeof onError === "function") {
          onError(err);
        }
        if (typeof onSettle === "function") {
          onSettle();
        }
      },
    } as getRequestInterface);
  };

  return { makeRequest, loading, responseData, error };
};
